// Shoplift → Noibu
// shoplift_test_{testId} = hypothesisId

(function () {
    function pushShopliftToNoibu() {
      try {
        const data = window.shoplift?.getVisitorData?.();
        const tests = data?.visitorTests;
  
        if (!Array.isArray(tests) || !tests.length) return;
  
        tests.forEach((test) => {
          if (!test?.testId || !test?.hypothesisId) return;
  
          window.NOIBUJS?.addCustomAttribute?.(
            `shoplift_test_${test.testId}`,
            test.hypothesisId
          );
        });
      } catch (err) {
        console.error(err);
      }
    }
  
    function initShopliftNoibu(retries = 20) {
      if (
        !window.shoplift ||
        typeof window.shoplift.getVisitorData !== 'function' ||
        !window.NOIBUJS ||
        typeof window.NOIBUJS.addCustomAttribute !== 'function'
      ) {
        if (retries > 0) {
          setTimeout(() => initShopliftNoibu(retries - 1), 200);
        }
        return;
      }
  
      pushShopliftToNoibu();
    }
  
    // init
    initShopliftNoibu();
  })();